export const isRef = obj => obj && 'current' in obj
